import { render } from "./Paymentreview.vue?vue&type=template&id=5352e52e&scoped=true"
import script from "./Paymentreview.vue?vue&type=script&lang=js"
export * from "./Paymentreview.vue?vue&type=script&lang=js"

import "./Paymentreview.vue?vue&type=style&index=0&id=5352e52e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5352e52e"

export default script